"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M27.77 4.89H4.23a2.65 2.65 0 0 0-2.65 2.65v17a2.65 2.65 0 0 0 2.65 2.65h23.54a2.65 2.65 0 0 0 2.65-2.65v-17a2.65 2.65 0 0 0-2.65-2.65zm-7.83 1.3v19.7h-7.88V6.19zM2.88 24.54v-17a1.36 1.36 0 0 1 1.35-1.35h6.53v19.7H4.23a1.35 1.35 0 0 1-1.35-1.35zm26.24 0a1.35 1.35 0 0 1-1.35 1.35h-6.53V6.19h6.53a1.36 1.36 0 0 1 1.35 1.35z"
})));
module.exports = exports.default;